<template>
    <InputText
        v-model="model"
        v-bind="omit(['modelValue' as keyof InputTextProps], props)"
        @submit="emit('submit', ...$event)"
    />
</template>

<script setup lang="ts">
import { omit } from 'ramda'
import InputText from '../InputText/InputText.vue'
import type { InputTextProps } from '../InputText/types'

defineOptions({ inheritAttrs: false })

const props = defineProps<InputTextProps & {
    placeholder?: string
}>()

const emit = defineEmits(['submit'])

const model = defineModel<string>()
</script>
